import React from 'react';
import { useIntl } from 'react-intl';
import styles from './styles.css';
import { ProgressIndicatorCopyType } from './types';

type ProgressIndicatorProps = {
  copyArray: Array<ProgressIndicatorCopyType>;
  step: number;
};
const ProgressIndicator = ({ copyArray, step }: ProgressIndicatorProps) => {
  const intl = useIntl();

  return (
    <div className={styles.progressBar}>
      {copyArray.map((item, index) => (
        <span
          key={item.copy}
          className={step === index ? styles.active : undefined}
        >
          {intl.formatMessage({ id: item.copy })}
        </span>
      ))}
    </div>
  );
};

export default ProgressIndicator;
